import {
  PIICategoryType,
  PIICategoryTypeMetadataArgs,
  getPIICategoryTypeListMetadata,
} from '../../assets/ts/data/pii/pii-category-type'
import useServerData from '../use-server-data'

function usePiiCategoryTypeMetadata(fetchArgs, waitOnParentDependency = false) {
  const {
    data: piiCategoryTypeMetadata,
    error: piiCategoryTypeMetadataError,
    fetchData: fetchPiiCategoryTypeMetadata,
    isLoading: piiCategoryTypeMetadataIsLoading,
  } = useServerData<PIICategoryType, PIICategoryTypeMetadataArgs>(
    getPIICategoryTypeListMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchPiiCategoryTypeMetadata,
    piiCategoryTypeMetadata,
    piiCategoryTypeMetadataError,
    piiCategoryTypeMetadataIsLoading,
  }
}

export default usePiiCategoryTypeMetadata
